import React, { useState, useEffect, useCallback } from 'react';
import { MdAdd } from 'react-icons/md';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import api from '~/services/api';
import history from '~/services/history';
// Importando componentes
import Card from '~/components/Card';
import Table from '~/components/Table';
import Load from '~/components/Load';

import { Container, Menus, NewButton } from './styles';

export default function Times() {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);
  const user = useSelector(state => state.user.profile);

  const getDados = useCallback(async () => {
    setLoading(true);
    const response = await api.get(
      `/incorporadora/${user.time.incorporadora_id}/time`
    );
    const data = response.data.map(i => {
      // Formatar numero
      if (i.telefone.length === 11) {
        const DD = i.telefone.substr(0, 2);
        const digitoNove = i.telefone.substr(2, 1);
        const primeiroBloco = i.telefone.substr(3, 4);
        const segundoBloco = i.telefone.substr(7, 4);
        const numeroFormatado = `(${DD}) ${digitoNove} ${primeiroBloco}-${segundoBloco}`;
        return {
          ...i,
          numeroFormatado,
          atende_sabado: i.atende_sabado === '1' ? 'Sim' : 'Não',
          atende_domingo: i.atende_domingo === '1' ? 'Sim' : 'Não',
          statusFormat: i.status === '1' ? 'Ativo' : 'Inativo',
          modelo_atendimento:
            i.modelo_atendimento === '1'
              ? 'Aleatorio'
              : 'Horario de trabalho do sdr',
        };
      }
      if (i.telefone.length === 10) {
        const DD = i.telefone.substr(0, 2);
        const primeiroBloco = i.telefone.substr(2, 4);
        const segundoBloco = i.telefone.substr(6, 4);
        const numeroFormatado = `(${DD}) ${primeiroBloco}-${segundoBloco}`;
        return {
          ...i,
          numeroFormatado,
          atende_sabado: i.atende_sabado === '1' ? 'Sim' : 'Não',
          atende_domingo: i.atende_domingo === '1' ? 'Sim' : 'Não',
          statusFormat: i.status === '1' ? 'Ativo' : 'Inativo',
          modelo_atendimento:
            i.modelo_atendimento === '1'
              ? 'Aleatorio'
              : 'Horario de trabalho do sdr',
        };
      }

      return {
        ...i,
        numeroFormatado: i.telefone,
        atende_sabado: i.atende_sabado === '1' ? 'Sim' : 'Não',
        atende_domingo: i.atende_domingo === '1' ? 'Sim' : 'Não',
        statusFormat: i.status === '1' ? 'Ativo' : 'Inativo',
        modelo_atendimento:
          i.modelo_atendimento === '1'
            ? 'Aleatorio'
            : 'Horario de trabalho do sdr',
      };
    });
    setDados(data);
    setLoading(false);
  }, [user]);

  useEffect(() => {
    getDados();
  }, [getDados]);

  /**
   * Funções
   */

  async function handlerStatus(number, numberIncorporadora) {
    try {
      setLoading(true);
      if (number.length > 1) {
        const res = number.map(async num => {
          const ds = numberIncorporadora.map(async inc => {
            const response = await api.delete(
              `/incorporadora/${inc}/time/${num}`
            );

            return response.data;
          });
          return ds;
        });
        const tr = Promise.all(res);
        const df = Promise.resolve(tr);
        df.then(result => {
          if (result[0] !== undefined) {
            toast.success('Time ativado/desativado com sucesso');
            getDados();
          }
        });
      } else {
        const response = await api.delete(
          `/incorporadora/${numberIncorporadora}/time/${number}`
        );

        if (response.data) {
          toast.success('Time ativado/desativado com sucesso');
          getDados();
        }
      }
    } catch (error) {
      toast.error('Error ao ativar/desativar o time');
      getDados();
    } finally {
      setLoading(false);
    }
  }

  function handlerEditar(number) {
    history.push(`/times-edit/${number}`);
  }

  // Criando dados da coluna
  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'name',
      label: 'Nome',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'incorporadora.name',
      label: 'Incorporadora',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'numeroFormatado',
      label: 'Telefone',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'hora_abertura',
      label: 'Abertura',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'hora_encerramento',
      label: 'Encerramento',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'atende_sabado',
      label: 'Atende no sabado',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'atende_domingo',
      label: 'Atende no domingo',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'modelo_atendimento',
      label: 'Modelo de atendimento',
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: 'statusFormat',
      label: 'Status',
      options: {
        filter: true,
        sort: false,
      },
    },
  ];

  if (loading) {
    return <Load />;
  }

  return (
    <>
      <Container>
        <h4>Times</h4>
        <Card>
          <Menus>
            <NewButton to="/times-create">
              <MdAdd size={16} color="#FFF" />
              Novo
            </NewButton>
          </Menus>
          <Table
            title="Integrações"
            data={dados}
            columns={columns}
            ds={handlerStatus}
            ed={handlerEditar}
            messages="Você deseja ativar/desativar o time ?"
            st
          />
        </Card>
      </Container>
    </>
  );
}
